import { Component, EventEmitter, Output } from '@angular/core';
import { AssetSearchComponent } from '@zero/shared/ui-web-components';
import { Asset } from '@zero/shared/util-models';

@Component({
  selector: 'saving-plans-saving-plan-search',
  templateUrl: './saving-plan-search.component.html',
  imports: [AssetSearchComponent],
})
export class SavingPlanSearchComponent {
  @Output() public selectSavingsPlan = new EventEmitter<Asset>();
}
